module.exports = __webpack_public_path__ + "static/img/repayment.a228fde4.png";